import { ShippingMethod, TPCSShippingMethod } from 'types'
import { camelCaseToHumanReadable } from 'utils'

export const shippingMethodToName = Object.keys(ShippingMethod).reduce((acc: { [key: string]: string }, key) => {
  const value = ShippingMethod[key as keyof typeof ShippingMethod]
  acc[value] = key
  return acc
}, {})

export const getTPCSShippingMethodName = (id: number): string => {
  return TPCSShippingMethod[id] || ''
}

export const getShippingMethodsExcluding = (excluded: string[]): string => {
  const shippingMethodsNotSelectable = [ShippingMethod.UspsFirst.toString()]
  const allMethods = Object.values(shippingMethodToName)
    .filter(
      option =>
        !shippingMethodsNotSelectable.includes(ShippingMethod[option as keyof typeof ShippingMethod].toString()),
    )
    .map(option => camelCaseToHumanReadable(option))
  const excludedHumanReadable = excluded.map(value => camelCaseToHumanReadable(shippingMethodToName[value]))
  return allMethods.filter(method => !excludedHumanReadable.includes(method)).join(', ')
}
